module.exports = __webpack_public_path__ + "img/active-list4.77c723e6.png";